function bigImg(x) {
const element = document.querySelector(".header.color-scheme-6");

    if (window.matchMedia("(min-width: 1024px)").matches) {
        if (element) {
            element.classList.replace("header","headers");
            element.classList.replace("color-scheme-6", "color-scheme-6x");
        }
   }
}

function normalImg(x) {

const elements = document.querySelector(".headers.color-scheme-6x");

    if (window.matchMedia("(min-width: 1024px)").matches) {
        if (elements) {
            elements.classList.replace("headers","header");
            elements.classList.replace("color-scheme-6x", "color-scheme-6");
        }
    }
}